module.exports = __webpack_public_path__ + "img/Retail25.92f09cbb.png";